import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { THS_API, THS_API_PIS } from "../constants";

const ID_APP = process.env.REACT_APP_ID_APP || "";

const initialState = {
  id: "",
  name: "",
  email: "",
  role: "",
  apiStatus: "",
  employeeId: "",
  searchUnit: "",
};

export const getUserProfile = createAsyncThunk(
  "user/getUserProfileAPI",
  async () => {
    const response = await THS_API.get("/users/profile");
    const { user } = response.data.data;

    const response2 = await THS_API_PIS.get(
      `${process.env.REACT_APP_API_PERSONEL_INFO}`,
      {
        params: {
          Search_EmployeeCode: user?.data?.employeeId,
        },
      }
    );

    const { FNAME, LNAME } = response2.data.Entries.Entry[0];

    const fullName =
      user?.data?.employeeId && FNAME && LNAME
        ? `${FNAME} ${LNAME}`
        : user.fullName;

    return {
      ...user,
      fullName,
    };
  }
);

export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getUserProfile.pending, (state) => {
        state.apiStatus = "loading";
      })
      .addCase(getUserProfile.fulfilled, (state, action) => {
        const { email, registrations, fullName, id, data } = action.payload;

        const currentUser = registrations.find(
          (obj: any) => obj.applicationId === ID_APP
        ) || [{ roles: [""] }];

        const role = currentUser.roles[0];
        state.name = fullName;
        state.id = id;
        state.email = email;
        state.role = role;
        state.employeeId = data.employeeId;
        state.searchUnit = data.subDepartment;
        state.apiStatus = "success";
      })
      .addCase(getUserProfile.rejected, (state) => {
        state.apiStatus = "rejected";
      });
  },
});

export const selectUser = (state: any) => state.user;

export default userSlice.reducer;
